<template>
  <div>
    <!-- <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全て選択</el-checkbox> -->
    <el-card class="scrollBox" v-loading="isloading">
      <el-checkbox-group
        v-if="!authStatus"
        v-model="checkedStreams"
        @change="handleCheckedStreamsChange"
      >
        <el-row v-for="stream in streams" :key="stream.uuid">
          <el-checkbox :label="stream.uuid">{{ stream.stream_name }}</el-checkbox>
        </el-row>
      </el-checkbox-group>
      <span v-else>{{authFailedText}}</span>
    </el-card>
  </div>
</template>

<script>
// const streamsOptions = ['カメラA', 'カメラB', 'カメラC', 'カメラD', 'カメラE', 'カメラF', 'カメラG', 'カメラH', 'カメラI'];
export default {
  name: 'StreamList',
  props: {
    streamList: Object,
    authStatus: Boolean
  },

  data() {
    return {
      checkedStreams: [],
      isloading: true,
      authFailedText: ""
    };
  },

  computed: {
    streams: function () {
      return this.$store.state.streams
    },
  },

  methods: {
    handleCheckedStreamsChange(value) {
      this.checkedStreams = value;
      this.$emit("check", this.checkedStreams)
    }
  },

  async created(){
    await this.$store.dispatch('getStreams').finally(()=>{
      this.isloading = false
      this.authFailedText = this.authStatus ? "このアプリケーションで利用可能なライセンスを取得できませんでした。": ""
    });
  }
};
</script>

<style scoped>
div.scrollBox {
  min-width: 500px;
  height: 200px;
  overflow-y: scroll;
}
</style>